import BodyMounter from '../libs/BodyMounter';
import UIModal from './UIModal';
import ConfirmModal from './modals/ConfirmModal';
import { ref } from '@vue/composition-api';

function createModal (ModalComponent, data) {
  const open = ref(true);
  const mounter = new BodyMounter();
  const vm = mounter.mount(h => {
    return h(
      UIModal,
      {
        ref: 'modal',
        props: {
          open: open.value,
        },
        on: {
          close () {
            open.value = false;
          },
          closed () {
            mounter.destroy();
          },
        },
      },
      [
        h(ModalComponent, {
          ...data,
          ref: 'childModal',
        }),
      ]
    );
  });
  return vm.$refs.modal;
}

function confirm ({ component = ConfirmModal, ...props }) {
  const modal = createModal(component, { props });
  return new Promise(resolve => {
    modal.$once('confirm', args => {
      resolve({ confirmed: true, ...args });
    });
    modal.$once('close', () => {
      resolve({ confirmed: false });
    });
  });
};
export default function useModalService () {
  return {
    confirm: (...args) => confirm(...args),
    modal: (...args) => createModal(...args),
  };
};
